const PREFIXO = "veiculo:";

export const CAMPOS_VEICULO = [
  { label: "PLACA", apiKey: "placa", campoChave: true, obrigatoriedade: true },
  { label: "MARCA", apiKey: "marca" },
  { label: "MODELO", apiKey: "modelo" },
  { label: "COR", apiKey: "cor" },
  { label: "ANO", apiKey: "ano" },
  { label: "ANO MODELO", apiKey: "anoModelo", aliases: ["ANOMODELO", "ANO DO MODELO"] },
  {
    label: "TIPO COMBUSTÍVEL",
    apiKey: "combustivel",
    aliases: ["COMBUSTIVEL", "TIPO COMBUSTIVEL", "TIPO DE COMBUSTIVEL"],
  },
  { label: "CHASSI", apiKey: "chassi" },
];

export const marcadorVeiculo = (apiKey) => `${PREFIXO}${apiKey}`;

export const isCampoVeiculo = (campo) =>
  typeof campo?.values === "string" && campo.values.startsWith(PREFIXO);

export const isCampoPlaca = (campo) => campo?.values === marcadorVeiculo("placa");

export const isCampoBloqueado = (campo) =>
  isCampoVeiculo(campo) && !isCampoPlaca(campo);

export const isAtivoVeiculo = (ativo) =>
  (ativo?.camposPersonalizados || []).some(isCampoPlaca);

const APIKEYS_LEGADAS = { final_chassi: "chassi" };

export const apiKeyDoCampo = (campo) => {
  if (!isCampoVeiculo(campo)) return null;
  const apiKey = campo.values.slice(PREFIXO.length);
  return APIKEYS_LEGADAS[apiKey] || apiKey;
};

const normalizarLabel = (label) =>
  (label || "")
    .toString()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, " ")
    .trim();

const casaComCanonico = (campo, canonico) => {
  const alvo = normalizarLabel(campo.label);
  const aceitos = [canonico.label, ...(canonico.aliases || [])].map(
    normalizarLabel,
  );
  return aceitos.includes(alvo);
};

export const reconciliarVeiculo = (existentes = [], gerarId) => {
  const usados = new Set();
  const camposVeiculo = CAMPOS_VEICULO.map((canonico) => {
    const existente = existentes.find(
      (campo) =>
        !usados.has(campo.id) &&
        !isCampoVeiculo(campo) &&
        casaComCanonico(campo, canonico),
    );
    if (existente) {
      usados.add(existente.id);
      return {
        ...existente,
        values: marcadorVeiculo(canonico.apiKey),
        campoChave: !!canonico.campoChave,
        obrigatoriedade:
          existente.obrigatoriedade || !!canonico.obrigatoriedade,
      };
    }
    return {
      id: gerarId(),
      label: canonico.label,
      type: "string",
      values: marcadorVeiculo(canonico.apiKey),
      obrigatoriedade: !!canonico.obrigatoriedade,
      campoChave: !!canonico.campoChave,
    };
  });
  const extras = existentes.filter(
    (campo) => !usados.has(campo.id) && !isCampoVeiculo(campo),
  );
  return { camposVeiculo, extras };
};
